import React from 'react';
import './index.css';

// Components
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import AgentsSection from './components/AgentsSection';
import PricingSection from './components/PricingSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen gradient-bg">
      <Navigation />
      <HeroSection />
      <FeaturesSection />
      <AgentsSection />
      <PricingSection />
      <CTASection />
      <Footer />
    </div>
  );
}

export default App;
